module.exports = __webpack_public_path__ + "9a83df03929c2c0ce179f3d2eb0a52d9.svg";